module.exports = __webpack_public_path__ + "img/motor_no67.ac5725fa.jpg";